<template>
  <div class="article-empty-result">
    <div class="text-content">
      <h3 class="title">При указанных фильтрах не удалось найти никаких результатов</h3>
      <p class="description">
        Попробуйте изменить запрос или уточнить параметры поиска для получения более точных результатов
      </p>
    </div>
    <div class="image-wrapper">
      <img src="~/assets/images/pages/articles/empty-result.png" alt="Ничего не найдено">
    </div>
  </div>
</template>

<style lang="scss" scoped>
.article-empty-result {
  @extend %flex-column;

  align-items: center;
  justify-content: center;
  gap: 52px;
  width: 100%;

  @include vp-767 {
    gap: 32px;
  }

  > .text-content {
    @extend %flex-column;

    gap: 12px;
    text-align: center;

    > .title {
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      color: $color-default-black;
      margin: 0;

      @include vp-767 {
        font-size: 20px;
        line-height: 28px;
      }
    }

    > .description {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: $color-potato-50;
      margin: 0;

      @include vp-767 {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }

  > .image-wrapper {
    width: 378px;
    height: 378px;

    @include vp-767 {
      width: 280px;
      height: 280px;
    }

    > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
